<h3 *ngIf="message.show" style="display: flex;"><mat-icon inline="true" aria-hidden="false" color="primary" class="mr-2 red">error</mat-icon>Error</h3>
<p>{{message.message}}</p>
<button class="btn btn-sm btn-secondary" (click)="close()">Close</button>
